<template>
  <div>
    <!-- 内容区 -->
    <div class="content">
      <div class="w">
        <div v-html="page.pInfo"></div>
      </div>
    </div>
  </div>
</template>

<script>
import menus from '../utils/menu'
export default {
  data() {
    return {
      pageId: '',
      page: []
    }
  },
  created() {
    var menuActive = this.$route.name
    if (menuActive == this.$store.state.menuActive) {
    } else {
      var keys = Object.keys(menus)
      if (keys.findIndex(item => item == menuActive) != -1) {
        this.$store.commit('setMenuActive', menuActive)
      }
    }

    var query = this.$route.query
    if (query.pageId) {
      this.pageId = query.pageId
    }
    // 获取页面内容
    this.getPageDetail()
  },
  mounted() {},
  methods: {
    async getPageDetail() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/customPage/pageDetail?pageId=' + this.pageId)
      if (data.success) {
        this.page = data.data.page
      }
    }
  },
  watch: {},
  computed: {}
}
</script>

<style lang="less" scoped>
.nav_bar {
  background-color: #f5f5f5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.content {
  margin-top: 40px;
}
</style>
